// Backstage ItemCardGrid -- NS overrides (bxanv).
//
// Source: node_modules/@backstage/core-components/dist/layout/ItemCard/ItemCardGrid.esm.js
// JSS name: "BackstageItemCardGrid"
// Class key targeted: root
//
// Core zet `repeat(auto-fill, minmax(22em, 1fr))`: een kolom is minstens 22em
// (308px). Op een telefoon is het raster smaller (259px op /create/templates),
// dus de kaart stak uit en rekte de pagina op tot de mobiele onderbalk buiten
// beeld viel. `min(22em, 100%)` laat de kolom tot de rasterbreedte krimpen.
// Op desktop is 22em kleiner dan 100% en verandert er niets.

const itemCardGridBase = {
  root: {
    gridTemplateColumns: 'repeat(auto-fill, minmax(min(22em, 100%), 1fr))',
  },
};

export const BackstageItemCardGridLightOverrides = itemCardGridBase;
export const BackstageItemCardGridDarkOverrides = itemCardGridBase;
